import { lazy, type ReactElement } from "react";
import { PeopleSourceProvider } from "@playbookai/ui";
import { useTenantPeopleSource } from "../hooks/useTenantPeopleSource.js";

const TtiPage = lazy(async () => {
  const mod = await import("@playbookai/hoshin-feature");
  return { default: mod.TtiPage };
});

/**
 * The Target to Improve page at the module-neutral `/app/tti/:ttiId` (PB-5317).
 *
 * NOT a module route: `/app/tti` is absent from `ALL_MODULES` on purpose, so the
 * shell's deep-link bootstrap mints no instance-id segment and opens no tab for
 * it. That is what the page wants — it is reached from a Hoshin plan and from a
 * KPI, and belongs to neither tab.
 *
 * The people directory is injected here for the same reason Hoshin's own route
 * injects it: a TTI's owner is stored as a Keycloak id, the API can only name
 * the caller, and only the shell may know about the people API (ADR-0009).
 * Without this the owner field could neither name the owner nor offer anyone
 * on this route alone.
 *
 * The source provided here is the TENANT one, not the plan-scoped one the
 * X-Matrix uses: the TTI read never carries the plan id (PB-5317). The owner
 * field takes who is signed in and `resolve` from it, so its chip shows the
 * owner's name and "Not active" when they left (d47), and searches through
 * the TTI-addressed people search instead.
 */
export default function TtiRoute(): ReactElement {
  const peopleSource = useTenantPeopleSource();
  return (
    <PeopleSourceProvider source={peopleSource}>
      <TtiPage />
    </PeopleSourceProvider>
  );
}
